import axios 					from "axios";
import CustomToast   			from '../../components/widgets/toast'

const getToken = () => {
	return window.localStorage.getItem("token");
};

export const BASE_URL = !process.env.NODE_ENV || process.env.NODE_ENV === "production"
			? window._env_.REACT_APP_BASE_ENDPOINT
			: process.env.REACT_APP_BASE_ENDPOINT;

export const fetch_sadap = (path, type, params, isMultiparts) => {

	const URL_SADAP = `${BASE_URL}/${path}`;

	const HEADERS = {
		"Content-Type"						: isMultiparts == undefined || isMultiparts ? "multipart/form-data" : "application/json",
		"Access-Control-Allow-Origin"		: "*",
		"Access-Control-Allow-Headers"		: "Origin, X-Requested-With, Content-Type, Accept",
		"Cache-Control"						: "no-cache",
		Pragma								: "no-cache",
		Expires								: "0",
	};

	if (process.env.NODE_ENV && process.env.NODE_ENV !== "production") {
		HEADERS.Authorization = `Bearer ${getToken()}`;
	}

	axios.defaults.withCredentials = true;
	const promise = new Promise((resolve, reject) => {
		let payload = {
			url		: URL_SADAP,
			method	: type,
			headers	: HEADERS,
		}

		if(type.toLowerCase() == "get") {
			payload.params 			= params
		} else if(type.toLowerCase() == "get_download") {
			payload.params 			= params
			payload.responseType 	= 'blob' 
		} else {
			payload.data 			= params
		}

		axios(payload).then((response) => {
			resolve(response.data);
		}).catch((err) => {
			// CustomToast("danger", `${err.response.data.message}`)
			CustomToast("danger", `Terjadi Kesalahan`)
			console.log(err.response.data.message)

			if (err.response) {
				reject(err.response);
				if (err.response.status === 410 || err.response.status == 401) {
					localStorage.clear()
					window.location.href = "/login"
				}
			} else if (err.request) {
				reject(err.request);
			} else {
				reject(err);
			}
		});
	});

	return promise;
};

export const fetch_sadap_post_upload = (path, params, onUploadProgress) => {
	const BASE_URL = !process.env.NODE_ENV || process.env.NODE_ENV === "production" ? window._env_.REACT_APP_BASE_ENDPOINT : process.env.REACT_APP_BASE_ENDPOINT;
	const URL_SADAP = `${BASE_URL}/${path}`;
	const HEADERS = {
		"Content-Type"					: "multipart/form-data",
		"Access-Control-Allow-Origin"	: !process.env.NODE_ENV || process.env.NODE_ENV === "production" ? window._env_.REACT_APP_CORS_ORIGIN : ".underdev.tem, localhost:3000, .mapbox.com",
		"Cache-Control"					: "no-cache",
		Pragma							: "no-cache",
		Expires							: "0",
	};

	if (process.env.NODE_ENV && process.env.NODE_ENV !== "production") {
		HEADERS.Authorization = `Bearer ${getToken()}`;
	}

	axios.defaults.withCredentials = true;
	const promise = new Promise((resolve, reject) => {

		let payload = {
			url			: URL_SADAP,
			method		: "post",
			data		: params,
			headers		: HEADERS,
			...onUploadProgress
		}

		axios(payload).then((response) => {
			resolve(response.data);
		}).catch((err) => {
			if (err.response) {
				reject(err.response);
			} else if (err.request) {
				reject(err.request);
			} else {
				reject(err);
			}
		});

	});
	return promise;
}
